const Spacer = () => <div style={{ flex: 1 }}></div>;
export default Spacer;
